export { default } from './loadResources'
